import { useConfig } from "../components"

export const getFirstHalfPos = (program: any, period: any) => {
    const programStartValidity = program?.startDate
        ? (program?.startDate - program?.duration) / 1000
        : -1
    if (program?.optaDetails?.optaFirstHalf) return Number(program?.optaDetails?.optaFirstHalf);

    const firstHalf = period.find((p: any) => p?.id === 1)
    if (firstHalf?.start && programStartValidity) {
        const date = new Date(firstHalf.start)
        const timestamp = date.getTime() / 1000

        return timestamp - programStartValidity
    }
}

export const getSecondHalfPos = (program: any, period: any) => {
    const programStartValidity = program?.startDate
        ? (program?.startDate - program?.duration) / 1000
        : -1
    if (program?.optaDetails?.optaSecondHalf) return Number(program?.optaDetails?.optaSecondHalf);

    const secondHalf = period.find((p: any) => p?.id === 2)
    if (secondHalf?.start && programStartValidity) {
        const date = new Date(secondHalf.start)
        const timestamp = date.getTime() / 1000

        return timestamp - programStartValidity
    }
}

export const canShowEvents = (program: any, matchEvent: any) => {
    const { getConfig } = useConfig()

    const events = matchEvent?.events ?? [];
    const period = matchEvent?.period ?? [];

    const programStart = program?.startTime ?? -1
    const programEnd = program?.endTime ?? -1

    const isMatchLiveNow = () => !events?.find((event: any) => {
        const eventTimestamp = new Date(event?.timestamp).valueOf()
        return programStart >= eventTimestamp && eventTimestamp <= programEnd
    })

    const isMatchEventProgram = getConfig()?.opta?.liveSimulatorEnabled || isMatchLiveNow();
    const isOnDemandEvent = !program?.isLive?.();

    if (isOnDemandEvent) {
        /**
         * Means it is a On demand match. To be extensive it could concern VOD but Recordings in the future
         */
        return !!getSecondHalfPos(program, period) && !!getFirstHalfPos(program, period)
    } else {
        /**
         * Means it is a live match
         */
        if (isMatchEventProgram) {
            return true
        }
    }
    return false
}
